import { FC } from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "../ui/button";

interface SettingsTopBarProps {
  title: string;
  onBack?: () => void;
}

const SettingsTopBar: FC<SettingsTopBarProps> = ({ title, onBack }) => {
  return (
    <div className="flex items-center h-12 px-4 shrink-0 border-b border-gray-200">
      <div className="flex items-center gap-4">
        <Button
          onClick={onBack || (() => window.history.back())}
          variant="ghost"
          size="sm"
          className="flex items-center gap-2 h-8 px-3 text-sm text-gray-500 hover:bg-gray-200 hover:text-gray-900"
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h1 className="text-sm font-semibold text-gray-900">{title}</h1>
      </div>
    </div>
  );
};

export default SettingsTopBar; 